"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowContextMenu = void 0;
const React = __importStar(require("react"));
const utilities_1 = require("./utilities");
const portal_context_menu_1 = require("../portal-context-menu");
function IsUseRowContextMenuInstance(instance) {
    return !!instance.getContextMenuItems;
}
function useRowContextMenu(hooks) {
    // ContextMenu added to each row using a new column
    hooks.columns.push((columns, { instance }) => {
        if (!IsUseRowContextMenuInstance(instance)) {
            throw new Error("Missing required option 'getContextMenuItems' on table options");
        }
        // If row is outside current selection, implicitly clear selection
        const onShow = (row) => {
            if (utilities_1.IsRowSelectTableInstance(instance)
                && instance.selectedFlatRows.length
                && !instance.selectedFlatRows.some(selectedRow => selectedRow.id === row.id)) {
                instance.toggleAllRowsSelected(false);
            }
        };
        return [
            ...columns,
            {
                id: "contextmenu",
                width: "0px",
                Cell: ({ row }) => React.createElement(portal_context_menu_1.PortalContextMenu, { id: row.id, onShow: () => onShow(row) }, [...instance.getContextMenuItems(row, instance)])
            }
        ];
    });
    // Bit naff, have to mutate rows to wrap render() method
    hooks.prepareRow.push(row => {
        row.cells.forEach(cell => {
            const originalRender = cell.render;
            cell.render = (type, props) => {
                if (type === "Cell") {
                    return React.createElement(portal_context_menu_1.ContextMenuTrigger, { id: row.id, holdToDisplay: -1 }, originalRender("Cell", props));
                }
                else {
                    return originalRender(type, props);
                }
            };
        });
    });
}
exports.useRowContextMenu = useRowContextMenu;
//# sourceMappingURL=context-menu.js.map